import styled from 'styled-components';

import { brandColors } from '../../../constants/colors';

const { SUBZERO_HEX, WOLF_HEX } = brandColors;

type SwiperContainerProps = {
  paginationColor: typeof SUBZERO_HEX | typeof WOLF_HEX;
};

export const SwiperContainer = styled.div.attrs({
  className: 'relative px-4 lg:px-24 xl:px-48 w-[300px] sm:w-[400px] md:w-full'
})<SwiperContainerProps>`
  .swiper-pagination {
    position: absolute;
    bottom: -30px !important;
    font-size: 10px;
  }

  .swiper-pagination-bullet {
    cursor: pointer;
    margin: 5px;
    padding: 5px;
    border-radius: 50%;
    background-color: #8f8f8f;
  }

  .swiper-pagination-bullet-active {
    background-color: ${(props) => props.paginationColor};
  }
`;
